import { Component, OnDestroy, OnInit, HostBinding, HostListener, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreMediaService } from '@core/services/media.service';
import { UserService } from '@biz/_core/user/user.service';
import { Lib } from 'app/lib/lib';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit, OnDestroy {
  public horizontalMenu: boolean;
  public hiddenMenu: boolean;
  public coreConfig: any;
  public currentSkin: string;
  public prevSkin: string;
  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;


  @HostBinding('class.fixed-top')
  public isFixed = false;

  @HostBinding('class.navbar-static-style-on-scroll')
  public windowScrolled = false;

  // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == 'navbar-static-top' &&
      this.coreConfig.layout.type == 'horizontal'
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }
  private _unsubscribeAll: Subject<any>;


  constructor(
    public lib: Lib,
    public userService: UserService,
    private _coreMediaService: CoreMediaService,
    private _mediaObserver: MediaObserver,
  ) {
    // this._authService.theUser.subscribe(x => (this.theUser = x));

    this.languageOptions = {
      tr: { title: 'Türkçe', flag: 'tr' },
      en: { title: 'English', flag: 'us' },
      de: { title: 'German', flag: 'de' },
      fr: { title: 'French', flag: 'fr' },
      es: { title: 'Spanish', flag: 'es' },
      it: { title: 'Italian', flag: 'it' },
    };
    this._unsubscribeAll = new Subject();
  }

  // setLanguage(language): void {
  //   this.selectedLanguage = language;
  //   this._translateService.use(language);
  //   this._coreConfigService.setConfig({ app: { appLanguage: language } }, { emitEvent: true });
  // }
  toggleDarkSkin(userService: UserService) {
    this.lib._coreConfigService.getConfig().pipe(takeUntil(this._unsubscribeAll)).subscribe(config => { this.currentSkin = config.layout.skin; });

    this.prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this.lib._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this.lib._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
    }
    userService.setUserTheme(this.currentSkin).subscribe(_ => { });
  }

  logout() {
    this.lib.logout();
    this.lib.router.navigate(['/auth/login']);
  }

  ngOnInit(): void {
    this.lib._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      this.horizontalMenu = config.layout.type === 'horizontal';
      this.hiddenMenu = config.layout.menu.hidden === true;
      this.currentSkin = config.layout.skin;

      // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
      if (this.coreConfig.layout.type === 'vertical') {
        setTimeout(() => {
          if (this.coreConfig.layout.navbar.type === 'fixed-top') {
            this.isFixed = true;
          }
        }, 0);
      }
    });

    // Horizontal Layout Only: Add class fixed-top to navbar below large screen
    if (this.coreConfig.layout.type == 'horizontal') {
      // On every media(screen) change
      this._coreMediaService.onMediaUpdate.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        const isFixedTop = this._mediaObserver.isActive('bs-gt-xl');
        if (isFixedTop) {
          this.isFixed = false;
        } else {
          this.isFixed = true;
        }
      });
    }

  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  isActivePage(page): boolean { return window.location.href.endsWith(`/${page}`); }
}
